<template>
    <div class="main-block request-management">
        <div class="div col-12 p-0 d-flex align-items-start">
            <h4 class="">{{ $t('title.TaskLogs') }}</h4>
        </div>
        <div class="scrollable-block">
            <div class="col-12 row mt-3 m-0 p-0" style="min-height: 90%">
                <crud-table :columns="columns" :list-url="listUrl" ref="application-table" v-on:refresh="resetFilter">
                    <template slot>
                        <router-link :to="{ name: 'AddTaskLogs', params: { operation: 'add' } }"
                            class="btn btn-primary">
                            <b-icon icon="plus" class="icon-style"></b-icon>
                            {{ $t('title.addnew') }}
                        </router-link>
                    </template>

                    <template #cell(actions)="{ item }">
                        <b-button variant="Primary" @click="openModal">
                            <b-icon variant="danger" icon="trash" class="icon-style"></b-icon>
                        </b-button>
                        <div class="modal fade" id="deleteModal" tabindex="-1" aria-labelledby="deleteModalLabel"
                            aria-hidden="true">
                            <div class="modal-dialog modal-dialog-centered">
                                <div class="modal-content">
                                    <div class="modal-header">
                                        <h5 class="modal-title" id="deleteModalLabel">{{
                                            $t('title.confirmDeletionTaskLog')
                                        }}
                                        </h5>
                                    </div>
                                    <div class="modal-body">
                                        {{ $t('title.deleteTaskLog') }}

                                    </div>
                                    <div class="modal-footer">
                                        <button type="button" class="btn btn-secondary" @click="closeModal"> {{
                                            $t('title.cancel') }}</button>
                                        <button type="button" class="btn btn-danger" @click="deleteItem(item.id)"> {{
                                            $t('title.yes') }}</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <b-button variant="Primary"
                            @click="$router.push({ name: 'UpdateTaskLogs', params: { id: item.id, operation: 'edit' } })">
                            <b-icon variant="primary" icon="pencil-square" class="icon-style"></b-icon>
                        </b-button>
                    </template>

                    <template #cell(is_active)="{ item }">
                        <b-button variant="Primary" @click="toggleStatus(item.id, item.is_active)">
                            <b-icon :variant="item.is_active ? 'success' : 'secondary'"
                                :icon="item.is_active ? 'toggle-on' : 'toggle-off'" class="icon-style"></b-icon>
                        </b-button>
                    </template>
                </crud-table>
            </div>
        </div>
    </div>
</template>

<script>
import {
    request
} from "@/Util/Request";
import {
    mapState
} from "vuex";
import {
    Modal
} from "bootstrap";

const FILTER_FORM = {
    roles: null,
    statuses: null
};

const COLUMN_STATE = (self) => [{
    key: 'actions',
    label: self.$t('title.actions')
},
{
    key: 'task_id',
    label: self.$t('title.task_id'),
    sortable: true
},
{
    key: 'task_name',
    label: self.$t('title.task_name'),
    sortable: true
},
{
    key: 'recipient',
    label: self.$t('title.recipient'),
    sortable: true
},
{
    key: 'is_active',
    label: self.$t('title.status'),
    sortable: true
},
];

export default {
    data() {
        return {
            operation: '',
            query: {
                page: 1,
                perPage: 10,
            },
            pagination: {
                total: 0, // total rows
            },
            listUrl: 'admin/Task-Logs',
            filters: {
                ...FILTER_FORM
            },
            showPopup: false,
        };
    },
    methods: {

        openModal() {
            const modalElement = document.getElementById("deleteModal");
            this.modalInstance = new Modal(modalElement); // Initialize modal
            this.modalInstance.show();
        },
        closeModal() {
            if (this.modalInstance) {
                this.modalInstance.hide();
            }
        },

        async deleteItem(id) {
            try {

                const response = await request({
                    method: 'delete',
                    url: `/admin/Task-Logs/${id}`,
                });

                if (this.modalInstance) {
                    this.modalInstance.hide();
                    this.showToast(this.$t("title.TaskLogDeletedTitle"), this.$t("title.TaskLogDeletedMessage"));
                }
                this.$refs['application-table'].refreshTableData();
            } catch (error) {
                this.notifyError();
            }
        },
        async toggleStatus(id, is_active) {
            try {
                const response = await request({

                    method: 'get',
                    url: `/admin/Task-Logs/change-status/${id}`,
                });

                const titleKey = is_active == 1 ? "title.TaskLogDeactivatedTitle" : "title.TaskLogActivatedTitle";
                const messageKey = is_active == 1 ? "title.TaskLogDeactivatedMessage" : "title.TaskLogActivatedMessage";

                this.showToast(this.$t(titleKey), this.$t(messageKey), is_active == 1 ? null : 1);

                this.$refs['application-table'].refreshTableData();
            } catch (error) {
                this.notifyError();
            }
        },
        handleFilter() {
            this.$refs['application-table'].handleFilter(this.filters);
        },
        resetFilter() {
            this.filters = {
                ...FILTER_FORM
            };
        },
        showToast(title, msg, status) {
            const h = this.$createElement;
            const vNodesMsg = h('p', {
                class: ['text-center', 'mb-0']
            }, [msg]);
            const vNodesTitle = h('div', {
                class: ['d-flex', 'flex-grow-1', 'align-items-baseline', 'mr-2']
            },
                [h('strong', {
                    class: 'mr-2'
                }, title)]
            );

            this.$bvToast.toast([vNodesMsg], {
                title: [vNodesTitle],
                solid: true,
                variant: status === 1 ? 'primary' : 'danger',
            });
        }

    },
    computed: {
        columns() {
            return COLUMN_STATE(this);
        }
    }
};
</script>
